import Helpers from '../lib/Helpers'
import Countdown from 'countdown-js'
import Component from '../inherited/Component'

export default class CountdownTimer extends Component {
  constructor (elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
        this._elem = elem
        this._options = {...{
            epoch: 0,
            seperator: ':'
        }, ...this._options}
        this._timer = null
        this._timerElems = this._elem.querySelectorAll('[data-time]')
    }

    mount () {
        this._timer = Countdown.timer(new Date(this._options.epoch * 1000), (timeLeft) => {
            this._updateTimeElems(timeLeft)
        }, () => {
            this._updateTimeElems({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            }, false)
        })
    }

    _updateTimeElems (timeLeft, reachedZero = true) {
        for (let timeElem of this._timerElems) {
            let time = timeLeft[timeElem.dataset.time]
            if (time === 0 && reachedZero) {
                timeElem.classList.add('hide')
            } else {
                reachedZero = false
                timeElem.textContent = time
            }
        }
    }

    
}
